import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

import { QRCodeListProps } from '../types';
import QRCodeListItem from './QRCodeListItem';

function QRCodeList(props: QRCodeListProps) {
  const { qrCodes, onRefresh } = props;

  return (
    <Box>
      <Typography
        variant="subtitle2"
        color="text.secondary"
        sx={{ mb: 2, letterSpacing: '0.1em' }}
      >
        {qrCodes.length === 0 ? 'You haven\'t created any QR codes yet' : 'YOUR CODES'}
      </Typography>
      <Stack spacing={1}>
        {qrCodes.map((qrCode) => (
          <QRCodeListItem 
            key={qrCode.qrCodeId} 
            qrCode={qrCode} 
            onRefresh={onRefresh} 
          />
        ))}
      </Stack>
    </Box>
  );
}; 

export default QRCodeList;